
import Balance from "./Balance.jpg";
import Donjon from "./Donjon.jpg";
import Euryale from "./Euryale.jpg";
import Jester from "./Jester.jpg";
import Key from "./Key.jpg";
import Knight from "./Knight.jpg";
import Ruin from "./Ruin.jpg";
import Skull from "./Skull.jpg";
import Sun from "./Sun.jpg";

export const DECK_OF_MANY_OLD_THINGS_URLS = [
  Balance, 
  Donjon,
  Euryale,
  Jester,
  Key,
  Knight,
  Ruin,
  Skull,
  Sun
];
  